export const MOBILE = 360;
export const TABLET = 768;
export const DESKTOP = 1360;
export const WIDE = 1920;
